module.exports = function(app) {
	app.value('eprProviderValidationHelper', {count: 0, failed: 0, success: 0});
	app.directive('eprProviderValidator', ['eprProviderErrors', function(eprProviderErrors) {
		return {
			restrict: 'A',
			require: 'ngModel',
			scope: {
				providerInfo: '=eprProviderValidator'
			},

			link: function (scope, elm, attrs, ctrl) {
				ctrl.$parsers.push(function(value) {
					if (eprProviderErrors[scope.providerInfo]) {
						delete eprProviderErrors[scope.providerInfo];
					}
					return value;
				});
				ctrl.$validators.eprProviderValidator = function(modelValue, viewValue) { // jshint ignore: line
					if (eprProviderErrors && eprProviderErrors[scope.providerInfo]) {
						return false;
					}
					return true;
				};
			}
		};
	}]);

	app.value('eprProviderErrors', {});
	app.directive('eprProvider', [function() {
		var id = 1;
		//window.$scope = $scope;
		return {
			restrict: 'A',
			replace: false,
			template: require('directives/employee/eprProvider.html'),

			scope: {
				participant: '=eprProvider',
				editMode: '=',
				validationSuffix: '=?',
				index: '=?eprProviderIndex',
				additionalGroupInfo: '=?',
				groupNumber: '=?',
				employee: '=?'
			},

			controller: [
				'$scope', 'navigation', 'sessionData', 'services', '$filter', '$rootScope', 'modal',
				'employee', 'employerUtility', 'storage', '$state', 'brand', 'eprProviderErrors', '$q',
				'eprProviderValidationHelper', '$timeout', 'eprPlanCoverageHelper', 'coverageBuddy',
				function(
					$scope, navigation, sessionData, services, $filter, $rootScope, modal,
					employee, employerUtility, storage, $state, brand, eprProviderErrors, $q,
					eprProviderValidationHelper, $timeout, eprPlanCoverageHelper, coverageBuddy
				) {

					$scope.eprProviderErrors = eprProviderErrors;
					$scope.id = id++;

					$scope.physicianNumber = '',
					$scope.physicianName = '',
					$scope.establishedPatient = false;
					//window.$scope = $scope;
					if ($scope.employee && $scope.employee.data && $scope.employee.data.globalCoverageEffectiveDate) {
						$scope.effectiveDate = angular.copy($scope.employee.data.globalCoverageEffectiveDate);
					}
                    var TODAY = new Date();
                    $rootScope.$on('updateProviders', function(event, gpNumber,lob) {

                    	//var r = $scope.isDependentEnrolledInLob(depen, groupNumber, lob.lineOfBusiness);
                       var r = employee.editInProgress.data.dependents;
                       if(r){ r.forEach(function (dep){
                           var result = $scope.isDependentEnrolledInLob(dep, gpNumber, lob);
                           if(result){
                               if(dep.pin === $scope.participant.pin){

                                   employee.metadata.pcpData[gpNumber][$scope.index].effectiveDate = $scope.employee.data.globalCoverageEffectiveDate;
                                   employee.metadata.pcpData[gpNumber][$scope.index].physicianCancellationDate = '';
                                   employee.metadata.pcpData[gpNumber][$scope.index].cancelCode = '';
                                   // var m = dep.memberCoverages ;
                                   // m.forEach(function (memco){
                                   //     if(memco.groupNumber === gpNumber){
                                   //         if(memco.providerInformation){
                                   //             memco.providerInformation.physicianEffectiveDate = $scope.employee.data.globalCoverageEffectiveDate;
                                   //             memco.providerInformation.physicianCancellationDate = '';
                                   //             memco.providerInformation.cancelCode = '';
                                   //         }
                                   //     }
                                   // });
                               }

						   }

					   });}

                        var s = employee.editInProgress.data.subscriber.pin ;
                        if(s === $scope.participant.pin){
                            employee.metadata.pcpData[gpNumber][$scope.index].effectiveDate = $scope.employee.data.globalCoverageEffectiveDate;
                            employee.metadata.pcpData[gpNumber][$scope.index].physicianCancellationDate = '';
                            employee.metadata.pcpData[gpNumber][$scope.index].cancelCode = '';

						}

                        // var s = employee.editInProgress.data.subscriber.pin ;
							// s.forEach(function (memc){
							// 	if(memc.groupNumber === gpNumber){
							// 		if(memc.providerInformation){
                        //                 memc.providerInformation.physicianEffectiveDate = $scope.employee.data.globalCoverageEffectiveDate;
                        //                 memc.providerInformation.physicianCancellationDate = '';
                        //                 memc.providerInformation.cancelCode = '';
							// 		}
							// 	}
							// });
                        // employee.metadata.pcpData[gpNumber][$scope.index].effectiveDate = $scope.employee.data.globalCoverageEffectiveDate;
                        // employee.metadata.pcpData[gpNumber][$scope.index].physicianCancellationDate = '';
                        // employee.metadata.pcpData[gpNumber][$scope.index].cancelCode = '';



                        if ($scope.index !== undefined && employee.metadata.pcpData && employee.metadata.pcpData[$scope.groupNumber] && employee.metadata.pcpData[$scope.groupNumber][$scope.index]) {
                            $scope.effectiveDate = employee.metadata.pcpData[$scope.groupNumber][$scope.index].effectiveDate;
                            $scope.physicianCancellationDate = employee.metadata.pcpData[$scope.groupNumber][$scope.index].physicianCancellationDate;
                            $scope.cancelCode = employee.metadata.pcpData[$scope.groupNumber][$scope.index].cancelCode;
                        }


                    });
                    $rootScope.$on('updateProvidersOnTrash', function(event, gpNumber,lob, cancelDate, cancelReason) {
						var r = employee.editInProgress.data.dependents;
                        if(r){ r.forEach(function (dep){
                            var result = $scope.isDependentEnrolledInLob(dep, gpNumber, lob);
                            if(result){
                                if(dep.pin === $scope.participant.pin){
									employee.metadata.pcpData[gpNumber][$scope.index].physicianCancellationDate = cancelDate;
                                    employee.metadata.pcpData[gpNumber][$scope.index].cancelCode = cancelReason;
								}
							}
						});}
						var s = employee.editInProgress.data.subscriber.pin ;
                        if(s === $scope.participant.pin){
							employee.metadata.pcpData[gpNumber][$scope.index].physicianCancellationDate = cancelDate;
                            employee.metadata.pcpData[gpNumber][$scope.index].cancelCode = cancelReason;

                        }
                        if ($scope.index !== undefined && employee.metadata.pcpData && employee.metadata.pcpData[$scope.groupNumber] && employee.metadata.pcpData[$scope.groupNumber][$scope.index]) {
                            //$scope.effectiveDate = employee.metadata.pcpData[$scope.groupNumber][$scope.index].effectiveDate;
                            $scope.physicianCancellationDate = employee.metadata.pcpData[$scope.groupNumber][$scope.index].physicianCancellationDate;
                            $scope.cancelCode = employee.metadata.pcpData[$scope.groupNumber][$scope.index].cancelCode;
                        }
					});

                    $scope.isDependentEnrolledInLob = function(dependent, groupNumber, lineOfBusiness, isForCCC) {
                        var enrolled = false;
                        if (Array.isArray(dependent.memberCoverages)) {
                            dependent.memberCoverages.forEach(function(coverage) {
                                if (coverage.groupNumber === groupNumber && Array.isArray(coverage.memberLobs)) {

                                    var subscriberHasCurrentCoverage = false;
                                    if (isForCCC) {
                                        for (var i = 0; i < $scope.employee.data.subscriber.memberCoverages.length; ++i) {
                                            var subscriberGroupNumber = $scope.employee.data.subscriber.memberCoverages[i].groupNumber;
                                            if (subscriberGroupNumber === groupNumber && Array.isArray($scope.employee.data.subscriber.memberCoverages[i].memberLobs)) {
                                                $scope.employee.data.subscriber.memberCoverages[i].memberLobs.forEach(function(lob) {
                                                    if (lob.lineOfBusiness == lineOfBusiness) {
                                                        subscriberHasCurrentCoverage = lob.coverageEffectiveDate <= TODAY;
                                                    }
                                                });
                                            }
                                        }
                                    }

                                    coverage.memberLobs.forEach(function(lob) {
                                        if (
                                            lob.lineOfBusiness === lineOfBusiness &&
                                            (!lob.coverageEndDate || (lob.coverageEndDate >= TODAY))
                                        ) {
                                            if (isForCCC && subscriberHasCurrentCoverage) {
                                                enrolled = lob.coverageEffectiveDate <= TODAY;
                                            }
                                            else {
                                                enrolled = true;
                                            }
                                        }
                                    });
                                }
                            });
                        }
                        return enrolled;
                    };

					if ($scope.participant.memberCoverages && $scope.participant.memberCoverages.length > 0) {
						var i = $scope.participant.memberCoverages.length;
						while (i--) {
							if ($scope.participant.memberCoverages[i].memberLobs && $scope.participant.memberCoverages[i].memberLobs.length > 0) {
								if (!$scope.groupNumber || $scope.participant.memberCoverages[i].groupNumber == $scope.groupNumber) {
									var k = $scope.participant.memberCoverages[i].memberLobs.length;
									while (k--) {
										if ($scope.participant.memberCoverages[i].memberLobs[k].coverageType && $scope.participant.memberCoverages[i].memberLobs[k].coverageType.toLowerCase) {
											if ($scope.participant.memberCoverages[i].memberLobs[k].coverageType.toLowerCase() === "medical") {
												if ($scope.participant.memberCoverages[i].providerInformation) {
													// Found medical product, populate physican
													$scope.physicianNumber = $scope.participant.memberCoverages[i].providerInformation.physicianNumber || '',
													$scope.physicianName = $scope.participant.memberCoverages[i].providerInformation.physicianName || '',
													$scope.establishedPatient = $scope.participant.memberCoverages[i].providerInformation.existingPatientIndicator || false;
													$scope.effectiveDate = $scope.participant.memberCoverages[i].providerInformation.physicianEffectiveDate || '';
													$scope.physicianCancellationDate = $scope.participant.memberCoverages[i].providerInformation.physicianCancellationDate || '';
													$scope.cancelCode = $scope.participant.memberCoverages[i].providerInformation.cancelCode || '';
												}
											}
										}
									}
								}
							}
						}
					}
                    $rootScope.$on('updateProvidersonRevert', function() {

                        if ($scope.participant.memberCoverages && $scope.participant.memberCoverages.length > 0) {
                            var i = $scope.participant.memberCoverages.length;
                            while (i--) {
                                if ($scope.participant.memberCoverages[i].memberLobs && $scope.participant.memberCoverages[i].memberLobs.length > 0) {
                                    if (!$scope.groupNumber || $scope.participant.memberCoverages[i].groupNumber == $scope.groupNumber) {

                                        var k = $scope.participant.memberCoverages[i].memberLobs.length;
                                        while (k--) {
                                            if ($scope.participant.memberCoverages[i].memberLobs[k].coverageType && $scope.participant.memberCoverages[i].memberLobs[k].coverageType.toLowerCase) {
                                                if ($scope.participant.memberCoverages[i].memberLobs[k].coverageType.toLowerCase() === "medical") {
                                                    if ($scope.participant.memberCoverages[i].providerInformation) {
                                                        // Found medical product, populate physican
                                                        $scope.physicianNumber = $scope.participant.memberCoverages[i].providerInformation.physicianNumber || '',
                                                            $scope.physicianName = $scope.participant.memberCoverages[i].providerInformation.physicianName || '',
                                                            $scope.establishedPatient = $scope.participant.memberCoverages[i].providerInformation.existingPatientIndicator || false;
                                                        $scope.effectiveDate = $scope.participant.memberCoverages[i].providerInformation.physicianEffectiveDate || '';
                                                        // $scope.physicianCancellationDate = $scope.participant.memberCoverages[i].providerInformation.physicianCancellationDate || '';
                                                        // $scope.cancelCode = $scope.participant.memberCoverages[i].providerInformation.cancelCode || '';
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
					});














					// I take no joy in the code I write below, this is not the right way to do this but there's just too much to refactor now with too little time
					// - Welcome to this project! So glad you could join us

					// Glad we joined this project. Changed the type of pcpData to object from array.s
					employee.metadata.pcpData = employee.metadata.pcpData || {};
					employee.metadata.pcpData[$scope.groupNumber] = employee.metadata.pcpData[$scope.groupNumber] || [];
					$scope.$watch("physicianNumber", function(newValue) {
						employee.metadata.pcpData[$scope.groupNumber][$scope.index] = employee.metadata.pcpData[$scope.groupNumber][$scope.index] || {};
						employee.metadata.pcpData[$scope.groupNumber][$scope.index].physicianNumber = newValue;
					});
					$scope.$watch("physicianName", function(newValue) {
						employee.metadata.pcpData[$scope.groupNumber][$scope.index] = employee.metadata.pcpData[$scope.groupNumber][$scope.index] || {};
						employee.metadata.pcpData[$scope.groupNumber][$scope.index].physicianName = newValue;
					});
					$scope.$watch("establishedPatient", function(newValue) {
						employee.metadata.pcpData[$scope.groupNumber][$scope.index] = employee.metadata.pcpData[$scope.groupNumber][$scope.index] || {};
						employee.metadata.pcpData[$scope.groupNumber][$scope.index].establishedPatient = newValue;
					});
					$scope.$watch("effectiveDate", function(newValue) {
						employee.metadata.pcpData[$scope.groupNumber][$scope.index] = employee.metadata.pcpData[$scope.groupNumber][$scope.index] || {};
						employee.metadata.pcpData[$scope.groupNumber][$scope.index].effectiveDate = newValue;
					});
					$scope.$watch("physicianCancellationDate", function(newValue) {
						employee.metadata.pcpData[$scope.groupNumber][$scope.index] = employee.metadata.pcpData[$scope.groupNumber][$scope.index] || {};
						employee.metadata.pcpData[$scope.groupNumber][$scope.index].physicianCancellationDate = newValue;
					});
					$scope.$watch("cancelCode", function(newValue) {
						employee.metadata.pcpData[$scope.groupNumber][$scope.index] = employee.metadata.pcpData[$scope.groupNumber][$scope.index] || {};
						employee.metadata.pcpData[$scope.groupNumber][$scope.index].cancelCode = newValue;
					});

					if ($scope.index !== undefined && employee.metadata.pcpData && employee.metadata.pcpData[$scope.groupNumber] && employee.metadata.pcpData[$scope.groupNumber][$scope.index]) {
						$scope.physicianNumber = employee.metadata.pcpData[$scope.groupNumber][$scope.index].physicianNumber;
						$scope.physicianName = employee.metadata.pcpData[$scope.groupNumber][$scope.index].physicianName;
						$scope.establishedPatient = employee.metadata.pcpData[$scope.groupNumber][$scope.index].establishedPatient;
						$scope.effectiveDate = new Date(employee.metadata.pcpData[$scope.groupNumber][$scope.index].effectiveDate);
						$scope.physicianCancellationDate = employee.metadata.pcpData[$scope.groupNumber][$scope.index].physicianCancellationDate;
						$scope.cancelCode = employee.metadata.pcpData[$scope.groupNumber][$scope.index].cancelCode;
					}
					// I take no joy in the code I wrote above, this is not the right way to do this but there's just too much to refactor now with too little time
					// - Welcome to this project! So glad you could join us
					// I take no joy in the code I wrote above, this is not the right way to do this but there's just too much to refactor now with too little time
					// - Welcome to this project! So glad you could join us
					// I take no joy in the code I wrote above, this is not the right way to do this but there's just too much to refactor now with too little time
					// - Welcome to this project! So glad you could join us



					// Only populate data for the correct index
					if ($scope.index !== undefined && $scope.index == $state.params.PCPIndex) {
						$scope.physicianNumber = $state.params.PCPNumber;
						$scope.physicianName = decodeURIComponent($state.params.PCPNAME);
					}

					// TODO: Refactor this so brand logic is the same and not looking at a URL
					$scope.searchProviderDirectory = function() {
						employee.metadata.getGroupNameIsRunning = true;
                        if (sessionData.employerInfo.brandName == '6008' && $scope.additionalGroupInfo.planAreaCode && $scope.additionalGroupInfo.planAreaCode == '375') {
                            sessionData.isIbcAhpa = true;
                        }
                        //If it is IBC, skipping service call
						if((sessionData.employerInfo.brandName == '6008' && !sessionData.isIbcAhpa) || sessionData.employerInfo.brandName == '6009'){
                            employee.metadata.getGroupNameIsRunning = false;
                            openProvicerSearch("");
						} else{
                            services.rbsmbl.getGroupName().fetch($scope.groupNumber).then(
                                function(response) {
                                    employee.metadata.getGroupNameIsRunning = false;
                                    if (
                                        response &&
                                        response.data &&
                                        response.data.payload &&
                                        response.data.payload.providerDataList &&
                                        response.data.payload.providerDataList.providerDataRecord &&
                                        response.data.payload.providerDataList.providerDataRecord[0]
                                    ) {
                                        openProvicerSearch(response.data.payload.providerDataList.providerDataRecord[0].productName);
                                    }
                                },
                                function() {
                                    employee.metadata.getGroupNameIsRunning = false;
                                }
                            );
						}
					};

					function openProvicerSearch(productName){
                        $scope.participant = $scope.participant || {};
                        $scope.participant.contractId = $scope.groupNumber; // hack for employerUtility.configureFindADoc
                        var returnURL = '/employer/manage-employees/add/coverage';
                        // TEMP HACK for 10/13, force newWindow for all brands on edit flow
                        if ($state.current.name !== "employee.add.coverage") {
                            returnURL = '/employer/home';
                        }

                        var providerURLData = employerUtility.configureFindADoc(returnURL, $scope, productName, $scope.index);
                        var providerURL = providerURLData.url;

                        // TEMP HACK for 10/13, force newWindow for all brands on edit flow
                        if ($state.current.name !== "employee.add.coverage") {
                            providerURLData.newWindow = true;
                        }
                        if (providerURLData.newWindow) {
                            // ibc and mn
                            window.open( providerURL, '_blank');
                        } else {
                            storage.set('providerReturnSubscriberId', employee.data.subscriber.ssn);
                            storage.set('planCoverageOptIn', employee.metadata.planCoverageOptIn);
                            storage.set('pcpSelections', employee.metadata.pcpData);
                            storage.set('parentalAgreementNumber', employee.metadata.parentalAgreementNumber);
                            window.location.href = providerURL;
                        }
					}

					$scope.$on('validateProvider', function() {
						eprProviderValidationHelper.count++;
						console.debug('heard validateProvider');

						if ($scope.editMode) {
							var planEffectiveDate;
							if ($scope.employee && $scope.employee.data && $scope.employee.data.globalCoverageEffectiveDate) {
								planEffectiveDate = angular.copy($scope.employee.data.globalCoverageEffectiveDate);
							}
                            if (
                                eprPlanCoverageHelper &&
                                eprPlanCoverageHelper.futureEffective &&
                                eprPlanCoverageHelper.futureEffective[$scope.groupNumber] &&
                                eprPlanCoverageHelper.futureEffective[$scope.groupNumber].effectiveDate
                            ) {
                                planEffectiveDate = angular.copy(eprPlanCoverageHelper.futureEffective[$scope.groupNumber].effectiveDate);
                            }
							if (
								eprPlanCoverageHelper &&
								eprPlanCoverageHelper.planCoverage &&
								eprPlanCoverageHelper.planCoverage.medical &&
								eprPlanCoverageHelper.planCoverage.medical.effectiveDate
							) {
								planEffectiveDate = angular.copy(eprPlanCoverageHelper.planCoverage.medical.effectiveDate);
							}
							if (eprPlanCoverageHelper && eprPlanCoverageHelper.preexistingMedicalCoverageEffectiveDate) {
								planEffectiveDate = angular.copy(eprPlanCoverageHelper.preexistingMedicalCoverageEffectiveDate);
							}
							$q.all({
								coverages: services.eprsvc.coverages({
									version: 'v2',
									coverageType: 'medical',
									effectiveDate: $filter('date')(planEffectiveDate, 'MM-dd-yyyy'),
									zipCode: $scope.employee.data.subscriber.address.zipCode.base
								}).fetch(),
								additionalGroupInformation: services.eprsvc.additionalGroupInformation({ groupNumber: $scope.groupNumber }).fetch($filter('date')(planEffectiveDate, 'yyyy-MM-dd'))
							}).then( function(responses) {

								var additionalGroupInformation =
									responses && responses.additionalGroupInformation && responses.additionalGroupInformation.data && responses.additionalGroupInformation.data.payload;

								var group =
									responses && responses.coverages && responses.coverages.data && responses.coverages.data.payload &&
									responses.coverages.data.payload.find(function(v) { return v.groupNumber == $scope.groupNumber; });

								if (additionalGroupInformation && group) {
									if ($scope.physicianNumber || additionalGroupInformation.providerRequired) {
										var payload = {
											pcpNum: $scope.physicianNumber,
											ssn: $scope.participant.ssn || '',
											planAreaCde: additionalGroupInformation.planAreaCode || '363',
											dob: $filter('date')($scope.participant.birthDate, 'MM/dd/yyyy'),
											contractId: group.groupNumber,
											insuranceLineCde: group.products[0].icisProductType,
											pcpEffDte: $filter('date')($scope.effectiveDate, 'MM/dd/yyyy'),
											existingPatient: $scope.establishedPatient
										};


										// Object.keys(eprProviderErrors).forEach(function(v) { delete eprProviderErrors[v]; });
										services.rbsmbl.validatePcp().fetch(payload).then(
											function() {
												$timeout(function() {
													eprProviderValidationHelper.success++;
													$rootScope.$broadcast('providerValidated', true);
												}, 100);
											},
											function(error) {
												$timeout(function() {
													eprProviderValidationHelper.failed++;
													$rootScope.$broadcast('providerValidated', false);
													eprProviderErrors[$scope.id] = error.data.returnCodeDescription;
													$scope.getFormField('providerNumber').$validate();
												}, 100);
											}
										);
									}
									else {
										$timeout(function() {
											eprProviderValidationHelper.success++;
											$rootScope.$broadcast('providerValidated', true);
										}, 100);
									}
								}
								else {
									$timeout(function() {
										eprProviderValidationHelper.success++;
										$rootScope.$broadcast('providerValidated', true);
									}, 100);
								}
							});
						}
						else {
							$timeout(function() {
								eprProviderValidationHelper.success++;
								$rootScope.$broadcast('providerValidated', true);
							}, 100);
						}
					});

					$scope.$on('assignProvider', function(event, product) { // jshint ignore: line
						console.debug('heard assignProvider');
						for (var i = 0; i < $scope.participant.memberCoverages.length; ++i) {
							var coverage = $scope.participant.memberCoverages[i];

							if (coverage.groupNumber === $scope.groupNumber && $scope.physicianNumber != '') {
								coverage.providerInformation = {
									physicianNumber: $scope.physicianNumber || '',
									physicianName: $scope.physicianName || '',
									existingPatientIndicator: $scope.establishedPatient || false,
									physicianEffectiveDate: $filter('date')($scope.effectiveDate, 'MM/dd/yyyy'),
									physicianCancellationDate: $scope.physicianCancellationDate ? $filter('date')($scope.physicianCancellationDate, 'MM/dd/yyyy') : '',
									cancelCode: $scope.cancelCode || ''
								};
								delete $scope.participant.temporaryData;
							}
							// break;
						}
						$scope.$emit('providerAssigned');
					});

					$scope.getForm = function() {
						return $scope["providerValidation_" + $scope.validationSuffix];
					};

					$scope.getFormField = function(fieldName) {
						return ($scope.getForm() || {})[fieldName];
					};


					// Copy to others
					if ($scope.editMode) {
						$scope.$watch('participant.temporaryData', function(gnu, old) {
							if (gnu && gnu instanceof Object && gnu !== old) {
								Object.keys(gnu).forEach(function(key) { $scope[key] = gnu[key]; });
							}
						});

						$scope.metadata = employee.metadata;
						$scope.$watch('metadata', function() {
							employee.metadata.participantsWithMedical = coverageBuddy.getParticipantsWithMedical(employee.data, employee.metadata);
							$scope.showCopyToOthers = $scope.editMode && (employee.metadata.participantsWithMedical.length > 1);

							$scope.copyToOthers = function() {
								var copyToOthers = function(s, others, scope) {
									scope = scope || $scope;

									var selectedOthers = others.filter(function(o) { return o.isChecked; });

									scope.selectionNeeded = false;
									if (others.length > 1) {
										scope.selectionNeeded = selectedOthers.length < 1;
										if (scope.selectionNeeded) { return false; }
									}

									selectedOthers.forEach(function(o) {
										o.temporaryData = {
											physicianNumber: scope.physicianNumber,
											physicianName: scope.physicianName,
											establishedPatient: scope.establishedPatient,
											effectiveDate: scope.effectiveDate
										};
									});
									others.forEach(function(o) { delete o.isChecked; });
									return true;
								};

								var others = window.others = employee.metadata.participantsWithMedical.slice(0);
								others.splice(others.indexOf($scope.participant), 1);

								if (others.length > 1) {
									var modalScope = $scope.$new();
									modalScope.selected = $scope.participant;
									modalScope.others = others;
									modalScope.physicianNumber = $scope.physicianNumber;
									modalScope.physicianName = $scope.physicianName;
									modalScope.establishedPatient = $scope.establishedPatient;
									modalScope.effectiveDate = $scope.effectiveDate;
									modalScope.modalHeading = 'Copy ' + $scope.physicianNumber + ' ' + $scope.physicianName;

									modalScope.copyToOthers = function() {
										copyToOthers(modalScope.selected, modalScope.others, modalScope) && modalScope.closeModal();
									};
									modalScope.selectAll = function() {
										others.forEach(function(o) { o.isChecked = true; });
									};
									modalScope.nothingSelected = function(others) {
										return !others.some(function(o) { return o.isChecked; });
									};
									modal.open({
										template: require('pages/employee/modals/copyToOthers.html'),
										scope: modalScope,
										classes: 'epr-standard-modal large-modal'
									});
								}
								else {
									others[0].isChecked = true;
									copyToOthers($scope.participant, others);
								}
							};
						});
					}
				}
			]
		};
	}]);
};
